/**
 * The coupons a customer sees on their own Subscription tab. Mirrors `CouponRedemptionResponse`
 * from saas-stripe-service (GET /couponredemption/company).
 */
import { dateToFormat } from 'src/utils/date';

/**
 * Only what still discounts the account: a lapsed redemption is history for Ops, not something
 * the customer can act on. Newest first, so the code they just entered is on top.
 */
export function getActiveRedemptions(redemptions) {
  return (redemptions !== null && redemptions !== void 0 ? redemptions : []).filter(redemption => !redemption.isExpired).sort((a, b) => String(b.redeemedOn).localeCompare(String(a.redeemedOn)));
}

/** Null when the discount runs for as long as the redemption stands. */
export function formatRedemptionValidUntil(redemption) {
  return redemption.expiresOn ? dateToFormat(redemption.expiresOn) : null;
}